import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import {
  Box, Drawer, List, ListItemButton, ListItemIcon, ListItemText,
  AppBar, Toolbar, Typography, IconButton, Avatar, Menu, MenuItem, Divider
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  Router as RouterIcon,
  People as PeopleIcon,
  AssignmentInd as AssignmentIcon,
  Logout as LogoutIcon,
} from '@mui/icons-material';
import { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { ProtectedRoute } from './ProtectedRoute';

const DRAWER_WIDTH = 240;

const NAV_ITEMS = [
  { path: '/dashboard', label: '仪表盘', icon: <DashboardIcon /> },
  { path: '/nodes', label: '节点管理', icon: <RouterIcon /> },
  { path: '/users', label: '用户管理', icon: <PeopleIcon /> },
  { path: '/assignments', label: '授权分配', icon: <AssignmentIcon /> },
];

export function Layout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  return (
    <ProtectedRoute>
      <Box sx={{ display: 'flex' }}>
        <Drawer
          variant="permanent"
          sx={{
            width: DRAWER_WIDTH,
            '& .MuiDrawer-paper': {
              width: DRAWER_WIDTH,
              borderRight: '1px solid #e0e0e0',
            },
          }}
        >
          <Box sx={{ p: 2, textAlign: 'center' }}>
            <Typography variant="h6" fontWeight={700} color="primary">VProxy</Typography>
            <Typography variant="caption" color="text.secondary">企业代理管理平台</Typography>
          </Box>
          <Divider />
          <List sx={{ px: 1 }}>
            {NAV_ITEMS.map(item => (
              <ListItemButton
                key={item.path}
                selected={location.pathname === item.path}
                onClick={() => navigate(item.path)}
                sx={{ borderRadius: 2, mb: 0.5 }}
              >
                <ListItemIcon sx={{ minWidth: 36 }}>{item.icon}</ListItemIcon>
                <ListItemText primary={item.label} primaryTypographyProps={{ fontSize: 14 }} />
              </ListItemButton>
            ))}
          </List>
        </Drawer>

        <Box sx={{ flex: 1 }}>
          <AppBar position="static" color="transparent" elevation={0} sx={{ borderBottom: '1px solid #e0e0e0' }}>
            <Toolbar sx={{ justifyContent: 'flex-end' }}>
              <Typography variant="body2" sx={{ mr: 2, color: 'text.secondary' }}>
                {user?.displayName || user?.synoUsername}
              </Typography>
              <IconButton onClick={e => setAnchorEl(e.currentTarget)}>
                <Avatar sx={{ width: 32, height: 32, bgcolor: 'primary.main', fontSize: 14 }}>
                  {(user?.displayName || 'A')[0]}
                </Avatar>
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
              >
                <MenuItem disabled>{user?.email}</MenuItem>
                <Divider />
                <MenuItem onClick={logout}>
                  <ListItemIcon><LogoutIcon fontSize="small" /></ListItemIcon>
                  退出登录
                </MenuItem>
              </Menu>
            </Toolbar>
          </AppBar>
          <Box sx={{ p: 3 }}>
            <Outlet />
          </Box>
        </Box>
      </Box>
    </ProtectedRoute>
  );
}
